import { combineReducers } from '@reduxjs/toolkit'

import Booking from './bookingStore/booking/BookingReduce'
import BookingDetail from './bookingStore/bookingDetail/BookingDetailReduce'
import CatalogoListaSeleccion from './catalogos/CatalogoListaSeleccionReducer'
import Catalogos from './catalogos/CatalogosReducer'
import Deckplan from './deckplan/DeckplanReduce'

import Layout from './layout/LayoutReducer'
import MargenGananciasReducer from './margenGanancias/margenGananciasReducer'
import ActividadesReservas from './reservasStore/actividadesReservas/ActividadesReservas'
import ActividadReservasDetalles from './reservasStore/actividadReservaDetalles/ActividadReservaDetalles'
import ReservasOperaciones from './reservasStore/reservas/ReservasOperaciones'
import ReservasActions from './reservasStore/reservasActions/reservasActions'
import ReservasDetalles from './reservasStore/reservasDetalles/reservasDetalles'
import ReservasHistorico from './reservasStore/reservasHistorico/ReservasHistoricoRedux'

import TasaCambioReducer from './tasaCambio/tasaCambioReducer'
import UserReducer from './user/userReducer'

import { menuReservasApi } from '@/common/components/Layout/services/menuReservas.services'
import { usuarioActualApi } from '@/common/components/Layout/services/usuarioActual.services'
import NotificationsReducer from '@/common/components/Notifications/state/notificationsState'
import { catalogosApi } from '@/common/services/catalogos.services'
import ReservasMenuReducer from '@/core/store/reservasStore/menuReservas/reservasMenuReducer'
import MonedaReducer from '@/core/store/user/monedaReducer'
import { asignacionEjecutivosComercialesApi } from '@/modules/Administrator/AsignacionEjecutivosComerciales/services/asignacionEjecutivosComerciales.services'
import { configuracionReservasApi } from '@/modules/Administrator/ConfiguracionReservas/services/configuracionReservas.services'
import { historicoCambioReservaCentralizadaApi } from '@/modules/HistoricoCambioReservaCentralizada/services/historicoCambioReservaCentralizada.services'
import historicoCambioReservaCentralizadaUi from '@/modules/HistoricoCambioReservaCentralizada/state/historicoCambioReservaCentralizadaSlice'
import { dashboardOperativoDiaApi } from '@/modules/Home/components/DashboardOperativoDia/services/dashboardOperativoDia.services'
import { agenteOperativoApi } from '@/modules/Home/services/ejecutivoOperativo.services'
import { homeCountersApi } from '@/modules/Home/services/homeCounters.services'
import { operacionSemanalApi } from '@/modules/Home/services/operacionSemanal.services'
import MatrizConfigReducer from '@/modules/Operaciones/Matriz/states/matrizConfigState'
import { cartaReservaApi } from '@/modules/ReservasTemp/services/cartaReserva.services'
import { estadosLogicosApi } from '@/modules/ReservasTemp/services/estadosLogicos.services'
import { listasSeleccionApi } from '@/modules/ReservasTemp/services/listasSeleccion.services'
import { planPagoApi } from '@/modules/ReservasTemp/services/planPago.services'
import { reservaCentralizadaApi } from '@/modules/ReservasTemp/services/reservaCentralizada.services'
import { reservaCentralizadaBusinessApi } from '@/modules/ReservasTemp/services/reservaCentralizadaBusiness.services'
import { reservaCentralizadaDetalleApi } from '@/modules/ReservasTemp/services/reservaCentralizadaDetalle.services'
import { userConfigurationApi } from '@/modules/ReservasTemp/services/userConfiguration.services'
import CartaReservaModalReducer from '@/modules/ReservasTemp/state/cartaReservaModalState'
import DetalleReservaModalReducer from '@/modules/ReservasTemp/state/detalleReservaModalState'
import DragDropReducer from '@/modules/ReservasTemp/state/dragDropState'
import KanbanFilterReducer from '@/modules/ReservasTemp/state/kanbanFilterState'
import KanbanReducer from '@/modules/ReservasTemp/state/kanbanState'
import PageConfigReducer from '@/modules/ReservasTemp/state/pageConfigState'
import PlanPagosModalReducer from '@/modules/ReservasTemp/state/planPagosModalState'
import RegenerarListaPasajerosModalReducer from '@/modules/ReservasTemp/state/regenerarListaPasajerosModalState'
import ReservasReducer from '@/modules/ReservasTemp/state/reservasState'
import VerCartaModalReducer from '@/modules/ReservasTemp/state/verCartaModalState'
import { preferenciaMonedaApi } from '@/modules/Utility/services/preferenciaMoneda.services'

const rootReducers = combineReducers({
  ActividadesReservas,
  ActividadReservasDetalles,
  Booking,
  BookingDetail,
  CatalogoListaSeleccion,
  Catalogos,
  Deckplan,
  historicoCambioReservaCentralizadaUi,
  [historicoCambioReservaCentralizadaApi.reducerPath]: historicoCambioReservaCentralizadaApi.reducer,
  Layout,
  ReservasActions,
  ReservasDetalles,
  ReservasHistorico,
  ReservasOperaciones,
  ReservasReducer,
  KanbanReducer,
  CartaReservaModalReducer,
  RegenerarListaPasajerosModalReducer,
  VerCartaModalReducer,
  DetalleReservaModalReducer,
  PlanPagosModalReducer,
  DragDropReducer,
  UserReducer,
  MonedaReducer,
  NotificationsReducer,
  TasaCambioReducer,
  KanbanFilterReducer,
  MargenGananciasReducer,
  ReservasMenuReducer,
  PageConfigReducer,
  MatrizConfigReducer,
  [menuReservasApi.reducerPath]: menuReservasApi.reducer,
  [usuarioActualApi.reducerPath]: usuarioActualApi.reducer,
  [estadosLogicosApi.reducerPath]: estadosLogicosApi.reducer,
  [reservaCentralizadaBusinessApi.reducerPath]: reservaCentralizadaBusinessApi.reducer,
  [reservaCentralizadaApi.reducerPath]: reservaCentralizadaApi.reducer,
  [reservaCentralizadaDetalleApi.reducerPath]: reservaCentralizadaDetalleApi.reducer,
  [listasSeleccionApi.reducerPath]: listasSeleccionApi.reducer,
  [planPagoApi.reducerPath]: planPagoApi.reducer,
  [cartaReservaApi.reducerPath]: cartaReservaApi.reducer,
  [homeCountersApi.reducerPath]: homeCountersApi.reducer,
  [operacionSemanalApi.reducerPath]: operacionSemanalApi.reducer,
  [dashboardOperativoDiaApi.reducerPath]: dashboardOperativoDiaApi.reducer,
  [agenteOperativoApi.reducerPath]: agenteOperativoApi.reducer,
  [userConfigurationApi.reducerPath]: userConfigurationApi.reducer,
  [catalogosApi.reducerPath]: catalogosApi.reducer,
  [asignacionEjecutivosComercialesApi.reducerPath]: asignacionEjecutivosComercialesApi.reducer,
  [configuracionReservasApi.reducerPath]: configuracionReservasApi.reducer,
  [preferenciaMonedaApi.reducerPath]: preferenciaMonedaApi.reducer,
})

export default rootReducers
